import ReactJsonView from "@microlink/react-json-view";
import { FormLabel, TextField } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import styled from "styled-components";

import { useDynamicFormsTranslate } from "@ryde/redux";
import { ICustomField } from "@ryde/shared";

import { CellNotOverflowedStyled } from "../../grid";

export const JSONSmartViewerTemplate: FC<ICustomField> = ({
  name,
  formLabel,
  labelTranslated,
  jsonType,
}) => {
  const { control } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
    translatedText: labelTranslated,
  });
  const formValue = useWatch({ control, name });

  // Display-only fallback: react-json-view accepts only objects/arrays, so null
  // and primitives render as an empty structure matching the field's jsonType.
  const emptyBySchema = jsonType === "array" ? [] : {};
  const displaySrc =
    typeof formValue === "object" && formValue !== null
      ? formValue
      : emptyBySchema;

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, ...fieldRest } }) => (
          <InvisibleTextField value={value ?? ""} {...fieldRest} />
        )}
      />

      <FormLabel>{formLabelTranslated}</FormLabel>

      <CellNotOverflowedStyled>
        <ReactJsonView
          src={displaySrc}
          name={false}
          displayDataTypes={false}
          collapsed
        />
      </CellNotOverflowedStyled>
    </>
  );
};

const InvisibleTextField = styled(TextField)`
  display: none !important;
`;
